import { render, staticRenderFns } from "./printOwnerVotingList.vue?vue&type=template&id=bcf7928c&scoped=true"
import script from "./printOwnerVotingList.vue?vue&type=script&lang=js"
export * from "./printOwnerVotingList.vue?vue&type=script&lang=js"
import style0 from "./printOwnerVotingList.vue?vue&type=style&index=0&id=bcf7928c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf7928c",
  null
  
)

export default component.exports